import React, { useEffect, useState } from "react";
import { Table  } from "antd";
import CustomPagination from "../../../core/common/customPagination";
import { useLocation } from "react-router-dom";

interface DatatableProps {
  dataSource: any[];
  columns: any[];
  totalItems: number;
  Selection?: boolean;
  pageSize: number;
  loading?: boolean;
  // scrollY?: number;
  onPageChange?: (page: number, pageSize: number) => void;
  rowClassName?: (record: any, index: number) => string;
  expandable?: any;
  rowKey?: string | ((record: any) => string | number);
  currentPage: number;
  style?: React.CSSProperties;
  onRowClick?: (record: any) => void;
  selectedRow?: any
}

const Datatable: React.FC<DatatableProps> = ({
  columns,
  dataSource,
  totalItems,
  //  scrollY,
  Selection,
  pageSize,
  loading,
  onPageChange,
  rowClassName,
  expandable,
  rowKey,
  currentPage,
  style,
  onRowClick,
  selectedRow, 
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [filteredDataSource, setFilteredDataSource] = useState(dataSource);
  const [selections, setSelections] = useState<boolean>(!!Selection);

  const location = useLocation();

  // ------- SAFE PAGE SIZE FALLBACK -------
  const safePageSize =
    pageSize > 0
      ? pageSize
      : totalItems > 0
        ? totalItems
        : 1;

  const totalPages = Math.ceil(totalItems / safePageSize);

  // ------- EFFECTS -------
  useEffect(() => {
    setFilteredDataSource(dataSource);
  }, [dataSource]);

  useEffect(() => {
    setSelections(!!Selection);
  }, [Selection]);

  // ------- ROW SELECTION -------
  const onSelectChange = (newKeys: any[]) => {
    setSelectedRowKeys(newKeys);
  };
  const rowSelection = selections
    ? { selectedRowKeys, onChange: onSelectChange }
    : undefined;

  // Since all pagination is server-side, just pass the data through
  const paginatedData = loading
  ? []
  : dataSource;

  // ------- SERIAL NUMBER COLUMN -------
  const serialNumberColumn = {
    title: "#",
    dataIndex: "serial",
    key: "serial",
    width: 60,
    render: (_: any, __: any, idx: number) =>
      (currentPage - 1) * safePageSize + idx + 1,
  };

  // ------- BUILD FINAL COLUMNS -------
  const finalColumns = React.useMemo(() => {
  // While loading, don’t insert serial-number column at all
  if (loading) {
    return columns;
  }

  if (location.pathname.includes("/attendance-view/A")) {
    return columns;
  }

  const checkboxIndex = columns.findIndex((col) => col.key === "select");
  if (checkboxIndex !== -1) {
    const updated = [...columns];
    updated.splice(checkboxIndex + 1, 0, serialNumberColumn);
    return updated;
  }

  return [serialNumberColumn, ...columns];
  }, [columns, location.pathname, currentPage, safePageSize, loading]);

  // ------- HANDLER FOR PAGE CHANGE -------
  const handlePageChange = (page: number) => {
    if (onPageChange) {
      onPageChange(page, safePageSize);
    }
  };
console.log(" totalItems:", totalItems);
console.log(" currentPage:", currentPage);
console.log(" pageSize:", pageSize);
console.log(" totalPages:", Math.ceil(totalItems / pageSize));

  return (
    <>
      <div className="table-top-data" style={style}>
        <div className="row table-container" id="table-header">
          <div className="col-12 d-flex justify-content-between">
            {/* you can add search / filters here */}
          </div>
          <Table
            className="table datanew dataTable no-footer"
            rowSelection={rowSelection}
            columns={finalColumns}
            rowHoverable={false}
            dataSource={paginatedData}
            // scroll={scrollY ? { y: scrollY } : undefined}
            pagination={false}
            loading={loading}
            rowClassName={rowClassName}
            expandable={expandable}
            rowKey={rowKey}
            onRow={(record, index = 0) => ({
              onClick: () => onRowClick?.(record),
              className:
                (rowClassName ? rowClassName(record, index) : "") +
                (selectedRow && selectedRow.id === record.id ? " selected-candidate-row" : "")
            })}
            locale={{
              emptyText: loading ? null : undefined,
            }}
          />
        </div>
      </div>

      {totalItems > 0 && totalPages > 1 && (
        <CustomPagination
          currentPage={currentPage}
          totalPages={totalPages}
          pageSize={safePageSize}
          totalItems={totalItems}
          onPageChange={handlePageChange}
        />
      )}
    </>
  );
};

export default Datatable;
